import { Link } from "react-router-dom";
import { Newspaper, ArrowUpRight, ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

const XYZ_URL = "https://xyz.pl/pierwszy-rok-polskiej-strefy-ekonomicznej-w-kenii-polacy-produkuja-tuk-tuki/";

export const PressStrip = () => {
  const { lang, t } = useLang();
  const p = t.press;
  const q = lang === "en" ? "" : `?lang=${lang}`;
  return (
    <section id="press" className="relative bg-canvas bp-grid border-b border-technical py-16 sm:py-20" data-testid="press-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow flex items-center gap-3" data-testid="press-eyebrow">
              <Newspaper className="h-4 w-4" /> {p.eyebrow} · <span className="text-[#525964] normal-case tracking-normal">{p.outlet}</span>
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <blockquote className="mt-6 border-l-[3px] border-red-brand pl-6">
              <p data-testid="press-headline" className="font-display text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight leading-[1.1] text-ink">{lang === "pl" ? "„" : "“"}{p.headline}{lang === "pl" ? "”" : "”"}</p>
            </blockquote>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-6 max-w-2xl text-sm sm:text-base leading-relaxed text-[#525964]">{p.desc}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to={`/knowledge/polish-sez-kenya-ev-manufacturing${q}`} data-testid="press-cta-article" className="chamfer-sm inline-flex items-center gap-2 bg-ink px-5 py-3 font-mono-tech text-[11px] font-semibold uppercase tracking-[0.15em] text-[#f8f7f4] hover:bg-red-brand transition-colors">
                {p.cta} <ArrowUpRight className="h-4 w-4" />
              </Link>
              <a href={XYZ_URL} target="_blank" rel="noopener noreferrer" data-testid="press-source-link" className="chamfer-sm inline-flex items-center gap-2 border border-technical px-5 py-3 font-mono-tech text-[11px] font-semibold uppercase tracking-[0.15em] text-ink hover:border-red-brand transition-colors">
                {p.source} <ExternalLink className="h-4 w-4 text-red-brand" />
              </a>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:pt-10">
          <div className="grid grid-cols-2 gap-px bg-[rgba(22,24,27,0.12)] border border-technical" data-testid="press-facts">
            {p.facts.map((f, i) => (
              <Reveal key={f.label} delay={i * 0.06} className="bg-white p-5 sm:p-6">
                <div className="font-display text-2xl sm:text-3xl font-black tracking-tight text-red-brand">{f.val}</div>
                <div className="mt-1.5 font-mono-tech text-[9px] uppercase tracking-[0.14em] text-[#525964]">{f.label}</div>
              </Reveal>
            ))}
          </div>
          <p className="mt-3 font-mono-tech text-[9px] uppercase tracking-[0.15em] text-[#9ca3af]">{p.attribution}</p>
        </div>
      </div>
    </section>
  );
};
